export default __webpack_public_path__ + "static/media/usa_flag_icon.79866553.png";